import { log } from '@shared/log.browser.ts';
import type { SearchContext } from '@shared/types/types.ts';
import type { BlackFridaySliderPort } from '@tilelist/application/ports/BlackFridaySliderPort.ts';
import type { SelectionEvents } from '@tilelist/application/ports/SelectionEvents.ts';
import type { TrackingPort } from '@tilelist/application/ports/TrackingPort.ts';
import type { VariationLoader } from '@tilelist/application/ports/VariationLoader.ts';
import type { BlackFridaySliderItem, ProductItem, TileItem } from '@tilelist/domain/composition/TileListitem.ts';

export class ProductTileController {
    constructor(
        private readonly variationLoadingService: VariationLoader,
        private readonly trackingService: TrackingPort,
        private readonly selectionEvents: SelectionEvents,
        private readonly blackFridaySliderLoader: BlackFridaySliderPort,
    ) {}

    /**
 *
 *
 */
    async loadVariation(productItem: ProductItem, variationId: string): Promise<ProductItem> {
        const updated = await this.variationLoadingService.loadVariation(productItem, variationId);

        log.debug(`Tile loaded: ${productItem.localListPosition} (${variationId})`);
        return updated;
    }

    /**
 *
 */
    trackVisibility(item: TileItem): void {
        this.trackingService.trackTileVisibility(item);
    }

    /**
 *
 */
    trackClick(event: Event, productItem: ProductItem, rule: string): void {
        this.trackingService.trackClick(event, productItem, rule, this.selectionEvents.current().entryRule);
    }

    /*                                                                             */
    async loadBlackFridaySlider(searchContext: SearchContext): Promise<BlackFridaySliderItem> {
        const slider = await this.blackFridaySliderLoader.load(searchContext);
        this.trackingService.trackBlackFridaySliderLoaded(slider);
        return slider;
    }

    trackBlackFridaySliderVisible(tiles: ProductItem[]): void {
        this.trackingService.trackBlackFridaySliderVisible(tiles);
    }

    trackBlackFridaySliderBrowsed(tiles: ProductItem[]): void {
        this.trackingService.trackBlackFridaySliderBrowsed(tiles);
    }

    trackBlackFridaySliderClick(event: Event, productItem: ProductItem, rule: string): void {
        this.trackingService.trackBlackFridaySliderClick(
            event,
            productItem,
            rule,
            this.selectionEvents.current().entryRule,
        );
    }
}
